import React, { useState, Fragment } from "react";
import axios from "axios";
import { format } from "date-fns";
import moment from "moment";

const baseURL = import.meta.env.VITE_API_URL;

const ReportSales = () => {
  const [reportSales, setReportSales] = useState([]);
  const [date1, setDate1] = useState(moment().format("YYYY-MM-DD"));
  const [date2, setDate2] = useState(moment().format("YYYY-MM-DD"));
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [pageSize, setPageSize] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState({});

  const businessCode = localStorage.getItem("businessCode");
  const businessName = localStorage.getItem("businessName");
  const branchCodes = localStorage.getItem("branchCodes");

  const clearData = () => {
    setReportSales([]);
  };
  const formatDate = (dateString) => {
    return format(new Date(dateString), "MM/dd/yyyy");
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 2,
    }).format(amount);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      setIsOpen(true);
      await handleReportSales();
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!date1) errors.date1 = "Start Date is required";
    if (!date2) errors.date2 = "End Date is required";
    return errors;
  };

  const handleReportSales = async () => {
    setLoading(true);
    clearData();
    setCurrentPage(1);
    try {
      console.log(businessCode);
      const formattedDate1 = formatDate(date1);
      const formattedDate2 = formatDate(date2);
      const response = await axios.get(
        `${baseURL}/get/salesdetail?BusinessCode=${businessName}&BranchCode=${branchCodes}&date1=${formattedDate1}&date2=${formattedDate2}&Page=${currentPage}&PageSize=${pageSize}`
      );
      if (response.status === 204) {
        setReportSales([]);
      } else {
        setReportSales(response.data);
        const kodeCabangs = response.data.map((item) => item.KodeCabang);
        const initialIsOpen = {};
        kodeCabangs.forEach((kodeCabang) => {
          initialIsOpen[kodeCabang] = true;
        });
        setIsOpen(initialIsOpen);
        setIsDataFetched(true);
        setCurrentPage(1);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageSizeChange = (event) => {
    setPageSize(Number(event.target.value));
    setCurrentPage(1);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, reportSales.length);
  const currentData = reportSales.slice(startIndex, endIndex);
  const headers = [
    "Branch Code",
    "Branch Name",
    "Invoice Date",
    "Customer Name",
    "Leasing Name",
    "Insurance Name",
    "Invoice Number",
    "Model Name",
    "Net Total Price",
    "Down Payment Amount",
    "Leasing Amount",
    "Tenor",
  ];

  return (
    <div className="min-h-screen bg-gray-100 pt-20 px-5">
      <div className="max-w-7xl mx-auto bg-white p-8 rounded-lg shadow-lg">
        <h2 className="text-2xl font-semibold text-gray-800 mb-6">
          Report Sales Detail
        </h2>
        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-1 sm:grid-cols-4 gap-6 mb-6"
        >
          <div>
            <label
              htmlFor="date1"
              className="block mb-2 text-sm font-medium text-gray-700"
            >
              Start Date
            </label>
            <input
              type="date"
              id="date1"
              placeholder="Date 1"
              value={date1}
              className={`p-3 border w-full rounded-lg focus:outline-none focus:ring-2 ${errors.date1
                  ? "border-red-500 focus:ring-red-500"
                  : "focus:ring-blue-500"
                }`}
              onChange={(e) => setDate1(e.target.value)}
            />
            {errors.date1 && (
              <p className="text-red-500 text-sm mt-1">{errors.date1}</p>
            )}
          </div>

          <div>
            <label
              htmlFor="date2"
              className="block mb-2 text-sm font-medium text-gray-700"
            >
              End Date
            </label>
            <input
              type="date"
              id="date2"
              placeholder="Date 2"
              value={date2}
              className={`p-3 border w-full rounded-lg focus:outline-none focus:ring-2 ${errors.date2
                  ? "border-red-500 focus:ring-red-500"
                  : "focus:ring-blue-500"
                }`}
              onChange={(e) => setDate2(e.target.value)}
            />
            {errors.date2 && (
              <p className="text-red-500 text-sm mt-1">{errors.date2}</p>
            )}
          </div>
          <button
            type="submit"
            className="col-span-1 sm:col-span-4 bg-blue-600 text-white p-3 rounded-lg hover:bg-blue-700 transition duration-300 "
          >
            Generate Report
          </button>
        </form>

        {loading && <p className="text-blue-600">Loading...</p>}
        {isDataFetched && (
          <div>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border border-gray-300 rounded-lg shadow-md overflow-hidden">
                <thead className="bg-gray-50 border-b-2 border-gray-200">
                  <tr>
                    {headers.map((header) => (
                      <th
                        key={header}
                        className="px-4 py-2 text-left text-sm font-semibold text-gray-600 min-w-32"
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {Object.entries(
                    currentData.reduce((acc, item) => {
                      const kodeCabang = item["KodeCabang"];
                      if (!acc[kodeCabang]) {
                        acc[kodeCabang] = [];
                      }
                      acc[kodeCabang].push(item);
                      return acc;
                    }, {})
                  ).map(([kodeCabang, group]) => (
                    <Fragment key={kodeCabang}>
                      <tr className="bg-gray-100">
                        <th
                          colSpan={headers.length}
                          className="px-4 py-2 text-left text-sm font-semibold text-gray-600"
                        >
                          {kodeCabang}
                          <button
                            className="ml-2 text-gray-600 hover:text-gray-900"
                            onClick={() =>
                              setIsOpen({
                                ...isOpen,
                                [kodeCabang]: !isOpen[kodeCabang],
                              })
                            }
                          >
                            {isOpen[kodeCabang] ? <>&#9650;</> : <>&#9660;</>}
                          </button>
                        </th>
                      </tr>
                      {isOpen[kodeCabang] &&
                        group.map((item, index) => (
                          <tr
                            key={index}
                            className="hover:bg-gray-100 transition-colors"
                          >
                            <td className="px-4 py-2 text-sm text-gray-700">
                              {item.KodeCabang}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-700">
                              {item.NamaCabang}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-700">
                              {formatDate(item.InvDate)}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-700">
                              {item.CustName}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-700">
                              {item.LeasingName}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-700">
                              {item.InsName}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-700">
                              {item.InvNo}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-700">
                              {item.ModelName}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-700">
                              {formatCurrency(item.NetTotalPrice)}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-700">
                              {formatCurrency(item.DPAmt)}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-700">
                              {formatCurrency(item.LeasingAmount)}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-700">
                              {item.Tenor}
                            </td>
                          </tr>
                        ))}
                    </Fragment>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="mt-6 flex justify-between items-center">
              <div className="flex items-center space-x-4">
                <label htmlFor="pageSize" className="text-gray-700">
                  Show:
                </label>
                <select
                  id="pageSize"
                  value={pageSize}
                  onChange={handlePageSizeChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 p-2.5"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>
              <div className="flex items-center space-x-4">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300"
                >
                  Previous
                </button>
                <span>
                  Page {currentPage} of{" "}
                  {Math.ceil(reportSales.length / pageSize)}
                </span>
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage * pageSize >= reportSales.length}
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReportSales;
